import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { DatabaseService } from '../services/database.service';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  public token: string;

  constructor(
    private storage: Storage,
    private db: DatabaseService,
  ) {
    this.init();
  }

  async init() {
    const storage = await this.storage.create();
    if (storage)
      console.log("Storage created")
  }

  public async set(key: string, value: any): Promise<any> {
    console.log("Setting " + key + " to:");
    console.table(value);
    if (key === environment.tokenName && (!this.token || this.token === "")) {
      this.token = value;
    }
    this.updateDB(key, value);
    return await this.storage?.set(key, value);
  }

  public async get(key: string): Promise<any> {
    console.log("Getting " + key)
    return await this.storage?.get(key);
  }

  public async removeAll() {
    this.db.isReady().subscribe(async (res) => {
      if (res) {
        await this.db.deleteAll();
      }
    });
    return await this.storage?.clear();
  }

  public driver() {
    console.log("Storage Driver: " + this.storage?.driver);
  }

  updateDB(key: string, value: any) {
    this.db.isReady().subscribe(async (res) => {
      if (res) {
        const item = await this.db.getKeyValue(key);
        if (item) {
          console.log("item found")
          await this.db.updateValue(key, JSON.stringify(value));
        }
        else {
          console.log("item NOT found")
          this.db.addKeyValue(key, JSON.stringify(value));
        }
      }
    });
  }
}
